import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import { useModal } from '../contexts';

interface Props { }

function WorkflowReviewCompletedModal(props: Props) {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  return (
    <Modal
      title={
        <h3 className="font-gilroy font-semibold text-xl">
          {t("This review has already been completed!")}
        </h3>
      }
      className='flex flex-col items-center justify-center gap-4 text-center'
      primaryButtonProps={{
        text: t("OK"),
        onClick: () => closeModal(),
      }}
    >
      <div className={`overflow-auto w-full text-left`}>
        {t("No action required.")}
      </div>
    </Modal>
  );
}

export default WorkflowReviewCompletedModal;
